/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import axios from 'axios'

import { setAuthorizationConfig } from '@/utils/services'
import { handleThrowError } from '@/utils/fetch'
import { organizationsApiUrls } from '@/configs/api-urls/organization.api-urls'

const {
  base,
  userResourcePermissions,
  revokeUserPermissions: revoke,
  activateUserPermissions: activate,
  resourceAccessLogs
} = organizationsApiUrls

const getApiBaseUrl = (organizationId) => `${base}/${organizationId}/${userResourcePermissions}`

export const getUserResourcePermissions = async ({ organizationId }, getAccessToken) => {
  const config = await setAuthorizationConfig(getAccessToken)
  const apiBaseUrl = getApiBaseUrl(organizationId)

  return axios
    .get(apiBaseUrl, config)
    .then(res => res.data)
    .catch(err => handleThrowError('getUserResourcePermissions', err))
}

export const assignUserPermissions = async (
  { organizationId, data },
  getAccessToken
) => {
  const config = await setAuthorizationConfig(getAccessToken)
  const apiBaseUrl = getApiBaseUrl(organizationId)

  return axios
    .post(apiBaseUrl, data, config)
    .then(res => res.data)
    .catch(err => handleThrowError('assignUserPermissions', err))
}

export const revokeUserPermissions = async (
  { organizationId, permissionId },
  getAccessToken
) => {
  const config = await setAuthorizationConfig(getAccessToken)
  const apiBaseUrl = getApiBaseUrl(organizationId)

  return axios
    .put(
      `${apiBaseUrl}/${permissionId}/${revoke}`,
      {},
      config
    )
    .then(res => res.data)
    .catch(
      err => handleThrowError('revokeUserPermissions', err)
    )
}

export const activateUserPermissions = async (
  { permissionId, organizationId },
  getAccessToken
) => {
  const config = await setAuthorizationConfig(getAccessToken)
  const apiBaseUrl = getApiBaseUrl(organizationId)

  return axios
    .put(
      `${apiBaseUrl}/${permissionId}/${activate}`,
      {},
      config
    )
    .then(res => res.data)
    .catch(err => handleThrowError('activateUserPermissions', err))
}

export const getResourceAccessLogs = async (
  { organizationId },
  getAccessToken
) => {
  const config = await setAuthorizationConfig(getAccessToken)

  return axios
    .get(`${base}/${organizationId}/${resourceAccessLogs}`, config)
    .then(res => res.data)
    .catch(err => handleThrowError('getResourceAccessLogs', err))
}
